



export const OverlayShowTime = 1200;
